const dashboard = () => import(/* webpackPrefetch: true */ '@/views/private/index.vue')
const transactions = () => import(/* webpackPrefetch: true */ '@/views/private/transactions/index.vue')
const setting = () => import(/* webpackPrefetch: true */ '@/views/private/setting/index.vue')
const accounts = () => import(/* webpackPrefetch: true */ '@/views/private/accounts/index.vue')
const loans = () => import(/* webpackPrefetch: true */ '@/views/private/loans/index.vue')
const services = () => import(/* webpackPrefetch: true */ '@/views/private/services/index.vue')
const investments = () => import(/* webpackPrefetch: true */ '@/views/private/investments/index.vue')


const supplier = () => import(/* webpackPrefetch: true */ '@/views/private/supplier/index.vue')
const supplier_add = () => import(/* webpackPrefetch: true */ '@/views/private/supplier/add/index.vue')
const supplier_edit = () => import(/* webpackPrefetch: true */ '@/views/private/supplier/edit/_id.vue')
const supplier_detail = () => import(/* webpackPrefetch: true */ '@/views/private/supplier/_id.vue')

const customer_proses = () => import(/* webpackPrefetch: true */ '@/views/private/customer-proses/index.vue')
const customer_acc = () => import(/* webpackPrefetch: true */ '@/views/private/customer-acc/index.vue')
const customer_reject = () => import(/* webpackPrefetch: true */ '@/views/private/customer-reject/index.vue')

const customer = () => import(/* webpackPrefetch: true */ '@/views/private/customer/index.vue')
const customer_add = () => import(/* webpackPrefetch: true */ '@/views/private/customer/add/index.vue')
const customer_edit = () => import(/* webpackPrefetch: true */ '@/views/private/customer/edit/_id.vue')
const customer_detail = () => import(/* webpackPrefetch: true */ '@/views/private/customer/_id.vue')

const Plafon = () => import(/* webpackPrefetch: true */ '@/views/private/plafon/index.vue')

const pengajuan_customer = () => import(/* webpackPrefetch: true */ '@/views/private/pengajuan/customer/index.vue')
const pengajuan_customer_add = () => import(/* webpackPrefetch: true */ '@/views/private/pengajuan/customer/add/index.vue')
const pengajuan_customer_detail = () => import(/* webpackPrefetch: true */ '@/views/private/pengajuan/customer/_id.vue')

const toko = () => import(/* webpackPrefetch: true */ '@/views/private/toko/index.vue')
const toko_add = () => import(/* webpackPrefetch: true */ '@/views/private/toko/add/index.vue')
const toko_add_id = () => import(/* webpackPrefetch: true */ '@/views/private/toko/add/_id.vue')
const toko_edit = () => import(/* webpackPrefetch: true */ '@/views/private/toko/edit/_id.vue')
const toko_detail = () => import(/* webpackPrefetch: true */ '@/views/private/toko/_id.vue')

const user = () => import(/* webpackPrefetch: true */ '@/views/private/user/index.vue')
const user_add = () => import(/* webpackPrefetch: true */ '@/views/private/user/add/index.vue')
const user_edit = () => import(/* webpackPrefetch: true */ '@/views/private/user/edit/_id.vue')
const user_detail = () => import(/* webpackPrefetch: true */ '@/views/private/user/_id.vue')

const sales = () => import(/* webpackPrefetch: true */ '@/views/private/sales/index.vue')
const sales_add = () => import(/* webpackPrefetch: true */ '@/views/private/sales/add/index.vue')
const sales_edit = () => import(/* webpackPrefetch: true */ '@/views/private/sales/edit/_id.vue')
const sales_detail = () => import(/* webpackPrefetch: true */ '@/views/private/sales/_id.vue')


const product = () => import(/* webpackPrefetch: true */ '@/views/private/product/index.vue')
const product_add = () => import(/* webpackPrefetch: true */ '@/views/private/product/add/index.vue')
const product_edit = () => import(/* webpackPrefetch: true */ '@/views/private/product/edit/_id.vue')
const product_detail = () => import(/* webpackPrefetch: true */ '@/views/private/product/_id.vue')

const varian = () => import(/* webpackPrefetch: true */ '@/views/private/varian/index.vue')
const varian_add = () => import(/* webpackPrefetch: true */ '@/views/private/varian/add/index.vue')
const varian_edit = () => import(/* webpackPrefetch: true */ '@/views/private/varian/edit/_id.vue')
const varian_detail = () => import(/* webpackPrefetch: true */ '@/views/private/varian/_id.vue')
const varian_add_id = () => import(/* webpackPrefetch: true */ '@/views/private/varian/add/_id.vue')

const Visit = () => import(/* webpackPrefetch: true */ '@/views/private/visit/index.vue')

const Visit_jadwal = () => import(/* webpackPrefetch: true */ '@/views/private/jadwal_visit/index.vue')
const Visit_jadwal_detail = () => import(/* webpackPrefetch: true */ '@/views/private/jadwal_visit/_id.vue')
const Visit_jadwal_edit = () => import(/* webpackPrefetch: true */ '@/views/private/jadwal_visit/edit/_id.vue')
const Visit_jadwal_add = () => import(/* webpackPrefetch: true */ '@/views/private/jadwal_visit/add/_id.vue')

const Visit_laporan = () => import(/* webpackPrefetch: true */ '@/views/private/laporan-detail-visit/index.vue')
const Visit_laporan_detail = () => import(/* webpackPrefetch: true */ '@/views/private/laporan-detail-visit/_id.vue')

const Target = () => import(/* webpackPrefetch: true */ '@/views/private/target/index.vue')

const Presensi = () => import(/* webpackPrefetch: true */ '@/views/private/presensi/index.vue')
const Presensi_detail = () => import(/* webpackPrefetch: true */ '@/views/private/presensi/_id.vue')
const Presensi_edit = () => import(/* webpackPrefetch: true */ '@/views/private/presensi/edit/_id.vue')
const Presensi_add = () => import(/* webpackPrefetch: true */ '@/views/private/presensi/add/index.vue')

const Ijin = () => import(/* webpackPrefetch: true */ '@/views/private/ijin/index.vue')
const stok = () => import(/* webpackPrefetch: true */ '@/views/private/stok/index.vue')
const stok_detail = () => import(/* webpackPrefetch: true */ '@/views/private/stok/_id.vue')
const stok_in_order = () => import(/* webpackPrefetch: true */ '@/views/private/stok/in-order/index.vue')

const pembelian_warehouse = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/warehouse/index.vue')
const pembelian_warehouse_add = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/warehouse/add/index.vue')
const pembelian_warehouse_edit = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/warehouse/edit/_id.vue')
const pembelian_warehouse_detail = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/warehouse/_id.vue')

const pembelian_general_manager = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/general-manager/index.vue')
const pembelian_general_manager_add = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/general-manager/add/index.vue')
const pembelian_general_manager_edit = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/general-manager/edit/_id.vue')
const pembelian_general_manager_detail = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/general-manager/_id.vue')
const pembelian_permintaan_barang = () => import(/* webpackPrefetch: true */ '@/views/private/pembelian/permintaan-barang/index.vue')


const penerimaan = () => import(/* webpackPrefetch: true */ '@/views/private/penerimaan/index.vue')
const penerimaan_add = () => import(/* webpackPrefetch: true */ '@/views/private/penerimaan/add/index.vue')
const penerimaan_edit = () => import(/* webpackPrefetch: true */ '@/views/private/penerimaan/edit/_id.vue')
const penerimaan_detail = () => import(/* webpackPrefetch: true */ '@/views/private/penerimaan/_id.vue')
const penerimaan_detail_QC = () => import(/* webpackPrefetch: true */ '@/views/private/penerimaan/qc/_id.vue')


const penerimaan_qc = () => import(/* webpackPrefetch: true */ '@/views/private/pernerimaan-QC/index.vue')
const penerimaan_detail_qc = () => import(/* webpackPrefetch: true */ '@/views/private/pernerimaan-QC/_id.vue')
const penerimaan_qc_edit = () => import(/* webpackPrefetch: true */ '@/views/private/pernerimaan-QC/edit/_id.vue')


const finance_penerimaan = () => import(/* webpackPrefetch: true */ '@/views/private/finance/penerimaan/index.vue')
const finance_penerimaan_detail = () => import(/* webpackPrefetch: true */ '@/views/private/finance/penerimaan/_id.vue')

const finance_po = () => import(/* webpackPrefetch: true */ '@/views/private/finance/po/index.vue')
const finance_po_detail = () => import(/* webpackPrefetch: true */ '@/views/private/finance/po/_id.vue')

// const finance_bank = () => import(/* webpackPrefetch: true */ '@/views/private/finance/bank/index.vue')
// const finance_bank_detail = () => import(/* webpackPrefetch: true */ '@/views/private/finance/bank/_id.vue')

const finance_order = () => import(/* webpackPrefetch: true */ '@/views/private/finance/order/index.vue')
const finance_order_detail = () => import(/* webpackPrefetch: true */ '@/views/private/finance/order/_id.vue')

const finance_invoice = () => import(/* webpackPrefetch: true */ '@/views/private/finance/invoice-customer/index.vue')
const finance_invoice_detail = () => import(/* webpackPrefetch: true */ '@/views/private/finance/invoice-customer/_id.vue')
const finance_invoice_add = () => import(/* webpackPrefetch: true */ '@/views/private/finance/invoice-customer/add/index.vue')

const finance_invoice_supplier = () => import(/* webpackPrefetch: true */ '@/views/private/finance/invoice-supplier/index.vue')
const finance_invoice_supplier_detail = () => import(/* webpackPrefetch: true */ '@/views/private/finance/invoice-supplier/_id.vue')
const finance_invoice_supplier_add = () => import(/* webpackPrefetch: true */ '@/views/private/finance/invoice-supplier/add/index.vue')
const finance_pengajuan = () => import(/* webpackPrefetch: true */ '@/views/private/finance/pengajuan-akunting/index.vue')


const approval_order_general_manager = () => import(/* webpackPrefetch: true */ '@/views/private/approval-order/general-manager/index.vue')
const approval_order_general_manager_detail = () => import(/* webpackPrefetch: true */ '@/views/private/approval-order/general-manager/_id.vue')
const approval_order_general_manager_add = () => import(/* webpackPrefetch: true */ '@/views/private/approval-order/general-manager/add/index.vue')
const approval_order_general_manager_edit = () => import(/* webpackPrefetch: true */ '@/views/private/approval-order/general-manager/edit/_id.vue')

const approval_order_warehouse = () => import(/* webpackPrefetch: true */ '@/views/private/approval-order/warehouse/index.vue')
const approval_order_warehouse_detail = () => import(/* webpackPrefetch: true */ '@/views/private/approval-order/warehouse/_id.vue')
const approval_order_warehouse_add = () => import(/* webpackPrefetch: true */ '@/views/private/approval-order/warehouse/add/index.vue')
const approval_order_warehouse_edit = () => import(/* webpackPrefetch: true */ '@/views/private/approval-order/warehouse/edit/_id.vue')


const approval_pengajuan_barang_atasan = () => import(/* webpackPrefetch: true */ '@/views/private/pengajuan-barang/atasan/index.vue')
const approval_pengajuan_barang_atasan_detail = () => import(/* webpackPrefetch: true */ '@/views/private/pengajuan-barang/atasan/_id.vue')
const approval_pengajuan_barang_general_manager = () => import(/* webpackPrefetch: true */ '@/views/private/pengajuan-barang/general-manager/index.vue')
const approval_pengajuan_barang_general_manager_detail = () => import(/* webpackPrefetch: true */ '@/views/private/pengajuan-barang/general-manager/_id.vue')
const approval_pengajuan_barang_gudang = () => import(/* webpackPrefetch: true */ '@/views/private/pengajuan-barang/gudang/index.vue')
const approval_pengajuan_barang_gudang_detail = () => import(/* webpackPrefetch: true */ '@/views/private/pengajuan-barang/gudang/_id.vue')
const pengajuan_barang_upadte_harga_supplier = () => import(/* webpackPrefetch: true */ '@/views/private/pengajuan-barang/update-harga-supplier/index.vue')


const pembayaran_barang_kasir = () => import(/* webpackPrefetch: true */ '@/views/private/pembayaran-barang/kasir/index.vue')
const pembayaran_barang_akunting = () => import(/* webpackPrefetch: true */ '@/views/private/pembayaran-barang/akunting/index.vue')
const approval_pembayaran_barang_manager_keuangan = () => import(/* webpackPrefetch: true */ '@/views/private/pembayaran-barang/manager-keuangan/index.vue')
const approval_pembayaran_barang_general_manager = () => import(/* webpackPrefetch: true */ '@/views/private/pembayaran-barang/general-manager/index.vue')
const approval_pembayaran_barang_print_kasir = () => import(/* webpackPrefetch: true */ '@/views/private/pembayaran-barang/print-kasir/index.vue')

const delivery_bpb = () => import(/* webpackPrefetch: true */ '@/views/private/delivery/bpb/index.vue')
const delivery_bpb_detail = () => import(/* webpackPrefetch: true */ '@/views/private/delivery/bpb/_id.vue')
const delivery_bpb_add = () => import(/* webpackPrefetch: true */ '@/views/private/delivery/bpb/add/index.vue')
const delivery_bpb_edit = () => import(/* webpackPrefetch: true */ '@/views/private/delivery/bpb/edit/_id.vue')


const delivery_surat_jalan = () => import(/* webpackPrefetch: true */ '@/views/private/delivery/surat-jalan/index.vue')
const delivery_surat_jalan_detail = () => import(/* webpackPrefetch: true */ '@/views/private/delivery/surat-jalan/_id.vue')
const delivery_surat_jalan_add = () => import(/* webpackPrefetch: true */ '@/views/private/delivery/surat-jalan/add/index.vue')
const delivery_surat_jalan_edit = () => import(/* webpackPrefetch: true */ '@/views/private/delivery/surat-jalan/edit/_id.vue')

const delivery_proses_muat = () => import(/* webpackPrefetch: true */ '@/views/private/delivery/proses-muat/index.vue')
const delivery_proses_muat_detail = () => import(/* webpackPrefetch: true */ '@/views/private/delivery/proses-muat/_id.vue')

const vehicle = () => import(/* webpackPrefetch: true */ '@/views/private/vehicle/index.vue')
const vehicle_detail = () => import(/* webpackPrefetch: true */ '@/views/private/vehicle/_id.vue')
const vehicle_add = () => import(/* webpackPrefetch: true */ '@/views/private/vehicle/add/index.vue')
const vehicle_edit = () => import(/* webpackPrefetch: true */ '@/views/private/vehicle/edit/_id.vue')

const warehouse_order = () => import(/* webpackPrefetch: true */ '@/views/private/konfirmasi-pengirirman/index.vue')
const warehouse_order_detail = () => import(/* webpackPrefetch: true */ '@/views/private/konfirmasi-pengirirman/_id.vue')

const kasir_supplier = () => import(/* webpackPrefetch: true */ '@/views/private/kasir/supplier/index.vue')
const kasir_supplier_detail = () => import(/* webpackPrefetch: true */ '@/views/private/kasir/supplier/_id.vue')
const kasir_customer = () => import(/* webpackPrefetch: true */ '@/views/private/kasir/customer/index.vue')
const kasir_customer_detail = () => import(/* webpackPrefetch: true */ '@/views/private/kasir/customer/_id.vue')
const kasir_pengajuan = () => import(/* webpackPrefetch: true */ '@/views/private/kasir/pengajuan-barang/index.vue')
const kasir_pengajuan_detail = () => import(/* webpackPrefetch: true */ '@/views/private/kasir/pengajuan-barang/_id.vue')

const promo = () => import(/* webpackPrefetch: true */ '@/views/private/promo/index.vue')
const promo_detail = () => import(/* webpackPrefetch: true */ '@/views/private/promo/_id.vue')
const promo_add = () => import(/* webpackPrefetch: true */ '@/views/private/promo/add/index.vue')
const promo_edit = () => import(/* webpackPrefetch: true */ '@/views/private/promo/edit/_id.vue')

const return_data = () => import(/* webpackPrefetch: true */ '@/views/private/return/index.vue')
const return_detail = () => import(/* webpackPrefetch: true */ '@/views/private/return/_id.vue')

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: dashboard,
    meta: {
      title: "Dashboard"
    }
  },

  {
    path: "/transactions",
    name: "Transactions",
    component: transactions,
    meta: {
      title: "Transactions"
    }
  },

  {
    path: "/setting",
    name: "Setting",
    component: setting,
    meta: {
      title: "Setting"
    }
  },

  {
    path: "/accounts",
    name: "Accounts",
    component: accounts,
    meta: {
      title: "Accounts"
    }
  },

  {
    path: "/loans",
    name: "Loans",
    component: loans,
    meta: {
      title: "Loans"
    }
  },

  {
    path: "/services",
    name: "Services",
    component: services,
    meta: {
      title: "Services"
    }
  },

  {
    path: "/investments",
    name: "Investments",
    component: investments,
    meta: {
      title: "Investments"
    }
  },

  {
    path: "/user/supplier",
    name: "Management User",
    component: supplier,
    meta: {
      title: "Supplier"
    }
  },

  {
    path: "/user/supplier/add",
    name: "Management User",
    component: supplier_add,
    meta: {
      title: "Tambahkan Supplier"
    }
  },
  {
    path: "/user/supplier/edit/:id",
    name: "Management User",
    component: supplier_edit,
    meta: {
      title: "Mengubah Supplier"
    }
  },

  {
    path: "/user/supplier/detail/:id",
    name: "Management User",
    component: supplier_detail,
    meta: {
      title: "Detail Supplier"
    }
  },

  {
    path: "/customer/data",
    name: "Management Customer",
    component: customer,
    meta: {
      title: "Customer"
    }
  },

  {
    path: "/customer/data/add",
    name: "Management Customer",
    component: customer_add,
    meta: {
      title: "Tambah Customer"
    }
  },
  {
    path: "/customer/data/edit/:id",
    name: "Management Customer",
    component: customer_edit,
    meta: {
      title: "Ubah Customer"
    }
  },

  {
    path: "/customer/data/detail/:id",
    name: "Management Customer",
    component: customer_detail,
    meta: {
      title: "Detail Customer"
    }
  },

  {
    path: "/customer/plafon",
    name: "Management Customer",
    component: Plafon,
    meta: {
      title: "Customer Plafon"
    }
  },

  {
    path: "/customer/perubahan",
    name: "Management Customer",
    component: pengajuan_customer,
    meta: {
      title: "Perubahan Customer"
    }
  },

  {
    path: "/customer/perubahan/add",
    name: "Management Customer",
    component: pengajuan_customer_add,
    meta: {
      title: "Mengubah Customer"
    }
  },

  {
    path: "/customer/perubahan/detail/:id",
    name: "Management Customer",
    component: pengajuan_customer_detail,
    meta: {
      title: "Detail Perubahan Customer"
    }
  },

  {
    path: "/customer/toko",
    name: "Management Customer",
    component: toko,
    meta: {
      title: "Toko"
    }
  },

  {
    path: "/customer/toko/add",
    name: "Management Customer",
    component: toko_add,
    meta: {
      title: "Tambah Toko"
    }
  },
  {
    path: "/customer/toko/add/:id",
    name: "Management Customer",
    component: toko_add_id,
    meta: {
      title: "Tambah Toko"
    }
  },
  {
    path: "/customer/toko/edit/:id",
    name: "Management Customer",
    component: toko_edit,
    meta: {
      title: "Ubah Toko"
    }
  },

  {
    path: "/customer/toko/detail/:id",
    name: "Management Customer",
    component: toko_detail,
    meta: {
      title: "Detail Toko"
    }
  },


  {
    path: "/user/staff",
    name: "Management User",
    component: user,
    meta: {
      title: "Staff"
    }
  },

  {
    path: "/user/staff/add",
    name: "Management User",
    component: user_add,
    meta: {
      title: "Tambahkan Staff"
    }
  },
  {
    path: "/user/staff/edit/:id",
    name: "Management User",
    component: user_edit,
    meta: {
      title: "Mengubah Staff"
    }
  },
  {
    path: "/user/staff/detail/:id",
    name: "Management User",
    component: user_detail,
    meta: {
      title: "Detail Staff"
    }
  },

  {
    path: "/sales/staff",
    name: "Management Sales",
    component: sales,
    meta: {
      title: "Staff Sales"
    }
  },

  {
    path: "/sales/staff/add",
    name: "Management Sales",
    component: sales_add,
    meta: {
      title: "Tambah Staff Sales"
    }
  },
  {
    path: "/sales/staff/edit/:id",
    name: "Management Sales",
    component: sales_edit,
    meta: {
      title: "Ubah Staff Sales"
    }
  },
  {
    path: "/sales/staff/detail/:id",
    name: "Management Sales",
    component: sales_detail,
    meta: {
      title: "Detail Staff Sales"
    }
  },

  {
    path: "/product/data",
    name: "Management Produk",
    component: product,
    meta: {
      title: "Produk"
    }
  },

  {
    path: "/product/data/add",
    name: "Management Produk",
    component: product_add,
    meta: {
      title: "Tambah Produk"
    }
  },
  {
    path: "/product/data/edit/:id",
    name: "Management Produk",
    component: product_edit,
    meta: {
      title: "Ubah Produk"
    }
  },
  {
    path: "/product/data/detail/:id",
    name: "Management Produk",
    component: product_detail,
    meta: {
      title: "Detail Produk"
    }
  },

  {
    path: "/product/varian",
    name: "Management Produk",
    component: varian,
    meta: {
      title: "Varian"
    }
  },

  {
    path: "/product/varian/add",
    name: "Management Produk",
    component: varian_add,
    meta: {
      title: "Tambah Varian"
    }
  },
  {
    path: "/product/varian/add/:id",
    name: "Management Produk",
    component: varian_add_id,
    meta: {
      title: "Tambah Varian"
    }
  },
  {
    path: "/product/varian/edit/:id",
    name: "Management Produk",
    component: varian_edit,
    meta: {
      title: "Ubah Varian"
    }
  },
  {
    path: "/product/varian/:id",
    name: "Management Produk",
    component: varian_detail,
    meta: {
      title: "Detail Varian"
    }
  },

  {
    path: "/stok/data",
    name: "Management Stok",
    component: stok,
    meta: {
      title: "Stok"
    }
  },

  {
    path: "/stok/data/detail/:id",
    name: "Management Stok",
    component: stok_detail,
    meta: {
      title: "Detail Stok"
    }
  },

  {
    path: "/stok/in-order",
    name: "Management Stok",
    component: stok_in_order,
    meta: {
      title: "Stok In Order"
    }
  },


  {
    path: "/visit/data",
    name: "Management visit",
    component: Visit,
    meta: {
      title: "Visit"
    }
  },

  {
    path: "/visit/jadwal",
    name: "Management visit",
    component: Visit_jadwal,
    meta: {
      title: "Jadwal Visit"
    }
  },
  {
    path: "/visit/jadwal/detail/:id",
    name: "Management visit",
    component: Visit_jadwal_detail,
    meta: {
      title: "Detail Jadwal Visit"
    }
  },
  {
    path: "/visit/jadwal/edit/:id",
    name: "Management visit",
    component: Visit_jadwal_edit,
    meta: {
      title: "Edit Jadwal Visit"
    }
  },
  {
    path: "/visit/jadwal/add/:id",
    name: "Management visit",
    component: Visit_jadwal_add,
    meta: {
      title: "Tambah Jadwal Visit"
    }
  },
  
  {
    path: "/visit/laporan",
    name: "Management visit",
    component: Visit_laporan,
    meta: {
      title: "Laporan Visit Detail"
    }
  },
  {
    path: "/visit/laporan/detail/:id",
    name: "Management visit",
    component: Visit_laporan_detail,
    meta: {
      title: "Detail Laporan Visit"
    }
  },

  {
    path: "/sales/target",
    name: "Management Sales",
    component: Target,
    meta: {
      title: "Target Sales"
    }
  },

  {
    path: "/presensi/data",
    name: "Management Presensi",
    component: Presensi,
    meta: {
      title: "Presensi"
    }
  },

  {
    path: "/presensi/data/add",
    name: "Management Presensi",
    component: Presensi_add,
    meta: {
      title: "Presensi Masuk"
    }
  },
  {
    path: "/presensi/data/edit/:id",
    name: "Management Presensi",
    component: Presensi_edit,
    meta: {
      title: "Presensi Pulang"
    }
  },

  {
    path: "/presensi/data/detail/:id",
    name: "Management Presensi",
    component: Presensi_detail,
    meta: {
      title: "Detail Presensi"
    }
  },

  {
    path: "/presensi/ijin",
    name: "Management Presensi",
    component: Ijin,
    meta: {
      title: "Ijin"
    }
  },

  {
    path: "/pengajuan/pembelian-warehouse",
    name: "Management Permintaan & Penerimaan Pembelian",
    component: pembelian_warehouse,
    meta: {
      title: "Permintaan Pembelian"
    }
  },

  {
    path: "/pengajuan/pembelian-warehouse/add",
    name: "Management Permintaan & Penerimaan Pembelian",
    component: pembelian_warehouse_add,
    meta: {
      title: "Tambah Data Permintaan Pembelian"
    }
  },
  {
    path: "/pengajuan/pembelian-warehouse/edit/:id",
    name: "Management Permintaan & Penerimaan Pembelian",
    component: pembelian_warehouse_edit,
    meta: {
      title: "Ubah Data Permintaan Pembelian"
    }
  },
  {
    path: "/pengajuan/pembelian-warehouse/detail/:id",
    name: "Management Permintaan & Penerimaan Pembelian",
    component: pembelian_warehouse_detail,
    meta: {
      title: "Detail Permintaan Pembelian"
    }
  },

  {
    path: "/pengajuan/pembelian-general-manager",
    name: "Management Permintaan & Penerimaan Pembelian",
    component: pembelian_general_manager,
    meta: {
      title: "Permintaan Pembelian"
    }
  },

  {
    path: "/pengajuan/pembelian-general-manager/add",
    name: "Management Permintaan & Penerimaan Pembelian",
    component: pembelian_general_manager_add,
    meta: {
      title: "Tambah Data Permintaan Pembelian"
    }
  },
  {
    path: "/pengajuan/pembelian-general-manager/edit/:id",
    name: "Management Permintaan & Penerimaan Pembelian",
    component: pembelian_general_manager_edit,
    meta: {
      title: "Ubah Data Permintaan Pembelian"
    }
  },
  {
    path: "/pengajuan/pembelian-general-manager/detail/:id",
    name: "Management Permintaan & Penerimaan Pembelian",
    component: pembelian_general_manager_detail,
    meta: {
      title: "Detail Permintaan Pembelian"
    }
  },

  {
    path: "/pengajuan/penerimaan/data",
    name: "Management Permintaan & Penerimaan Pembelian",
    component: penerimaan,
    meta: {
      title: "Penerimaan"
    }
  },

  {
    path: "/pengajuan/penerimaan/data/add",
    name: "Management Permintaan & Penerimaan Pembelian",
    component: penerimaan_add,
    meta: {
      title: "Tambah Data Penerimaan"
    }
  },
  {
    path: "/pengajuan/penerimaan/data/edit/:id",
    name: "Management Permintaan & Penerimaan Pembelian",
    component: penerimaan_edit,
    meta: {
      title: "Ubah Data Penerimaan"
    }
  },
  {
    path: "/pengajuan/penerimaan/data/detail/:id",
    name: "Management Permintaan & Penerimaan Pembelian",
    component: penerimaan_detail,
    meta: {
      title: "Detail Penerimaan"
    }
  },
  {
    path: "/pengajuan/penerimaan/data/qc/detail/:id",
    name: "Management Permintaan & Penerimaan Pembelian",
    component: penerimaan_detail_QC,
    meta: {
      title: "Detail QC Penerimaan"
    }
  },

  {
    path: "/pengajuan/qc",
    name: "Management Permintaan & Penerimaan Pembelian",
    component: penerimaan_qc,
    meta: {
      title: "QC Penerimaan"
    }
  },

  {
    path: "/pengajuan/qc/edit/:id",
    name: "Management Permintaan & Penerimaan Pembelian",
    component: penerimaan_qc_edit,
    meta: {
      title: "Ubah QC Penerimaan"
    }
  },

  {
    path: "/pengajuan/qc/detail/:id",
    name: "Management Permintaan & Penerimaan Pembelian",
    component: penerimaan_detail_qc,
    meta: {
      title: "Detail QC Penerimaan"
    }
  },

  {
    path: "/finance/penerimaan/data",
    name: "Management Penerimaan Stok",
    component: finance_penerimaan,
    meta: {
      title: "Data Penerimaan"
    }
  },

  {
    path: "/finance/penerimaan/detail/:id",
    name: "Management Penerimaan Stok",
    component: finance_penerimaan_detail,
    meta: {
      title: "Detail Penerimaan"
    }
  },

  // {
  //   path: "/finance/bank",
  //   name: "Management Bank",
  //   component: finance_bank,
  //   meta: {
  //     title: "Bank"
  //   }
  // },

  {
    path: "/finance/order",
    name: "Management Order",
    component: finance_order,
    meta: {
      title: "Order"
    }
  },

  {
    path: "/finance/order/detail/:id",
    name: "Management Order",
    component: finance_order_detail,
    meta: {
      title: "Detail Order"
    }
  },

  {
    path: "/finance/invoice",
    name: "Management Invoice",
    component: finance_invoice,
    meta: {
      title: "Invoice"
    }
  },

  {
    path: "/finance/invoice/detail/:id",
    name: "Management Invoice",
    component: finance_invoice_detail,
    meta: {
      title: "Detail Invoice"
    }
  },

  {
    path: "/finance/invoice/add",
    name: "Management Invoice",
    component: finance_invoice_add,
    meta: {
      title: "Tambah Invoice"
    }
  },

  {
    path: "/finance/invoice-supplier",
    name: "Management Invoice",
    component: finance_invoice_supplier,
    meta: {
      title: "Invoice Supplier"
    }
  },

  {
    path: "/finance/invoice-supplier/detail/:id",
    name: "Management Invoice",
    component: finance_invoice_supplier_detail,
    meta: {
      title: "Detail Invoice Supplier"
    }
  },

  {
    path: "/finance/invoice-supplier/add",
    name: "Management Invoice",
    component: finance_invoice_supplier_add,
    meta: {
      title: "Tambah Invoice Supplier"
    }
  },

  {
    path: "/finance/po/data",
    name: "Management Penerimaan Stok",
    component: finance_po,
    meta: {
      title: "Data Close PO"
    }
  },

  {
    path: "/finance/po/detail/:id",
    name: "Management Penerimaan Stok",
    component: finance_po_detail,
    meta: {
      title: "Detail Close PO"
    }
  },

  {
    path: "/approval/order",
    name: "Management Approval",
    component: approval_order_general_manager,
    meta: {
      title: "Approval Order"
    }
  },

  {
    path: "/approval/order/detail/:id",
    name: "Management Approval",
    component: approval_order_general_manager_detail,
    meta: {
      title: "Detail Approval Order"
    }
  },

  {
    path: "/approval/order/add",
    name: "Management Approval",
    component: approval_order_general_manager_add,
    meta: {
      title: "Tambah Approval Order"
    }
  },

  {
    path: "/approval/order/edit/:id",
    name: "Management Approval",
    component: approval_order_general_manager_edit,
    meta: {
      title: "Ubah Approval Order"
    }
  },

  {
    path: "/approval/order-warehouse",
    name: "Management Approval",
    component: approval_order_warehouse,
    meta: {
      title: "Approval Order"
    }
  },

  {
    path: "/approval/order-warehouse/detail/:id",
    name: "Management Approval",
    component: approval_order_warehouse_detail,
    meta: {
      title: "Detail Approval Order"
    }
  },

  {
    path: "/approval/order-warehouse/add",
    name: "Management Approval",
    component: approval_order_warehouse_add,
    meta: {
      title: "Tambah Approval Order"
    }
  },

  {
    path: "/approval-permintaan/order-warehouse/edit/:id",
    name: "Management Approval",
    component: approval_order_warehouse_edit,
    meta: {
      title: "Ubah Approval Order"
    }
  },



  {
    path: "/pengajuan-barang/data",
    name: "Management Pengajuan Barang",
    component: pembelian_permintaan_barang,
    meta: {
      title: "Permintaan Pembelian Barang"
    }
  },

  {
    path: "/pengajuan-barang/approval-atasan",
    name: "Management Pengajuan Barang",
    component: approval_pengajuan_barang_atasan,
    meta: {
      title: "Approval Pengajuan Barang"
    }
  },

  {
    path: "/pengajuan-barang/approval-atasan/detail/:id",
    name: "Management Pengajuan Barang",
    component: approval_pengajuan_barang_atasan_detail,
    meta: {
      title: "Detail Approval Pengajuan Barang"
    }
  },

  {
    path: "/pengajuan-barang/approval-general-manager",
    name: "Management Pengajuan Barang",
    component: approval_pengajuan_barang_general_manager,
    meta: {
      title: "Approval Pengajuan Barang"
    }
  },

  {
    path: "/pengajuan-barang/approval-general-manager/detail/:id",
    name: "Management Pengajuan Barang",
    component: approval_pengajuan_barang_general_manager_detail,
    meta: {
      title: "Detail Approval Pengajuan Barang"
    }
  },

  {
    path: "/pengajuan-barang/approval-gudang",
    name: "Management Pengajuan Barang",
    component: approval_pengajuan_barang_gudang,
    meta: {
      title: "Approval Pengajuan Barang"
    }
  },

  {
    path: "/approval-permintaan/pengajuan-barang-gudang/detail/:id",
    name: "Management Pengajuan Barang",
    component: approval_pengajuan_barang_gudang_detail,
    meta: {
      title: "Detail Approval Pengajuan Barang"
    }
  },

  {
    path: "/pengajuan-barang/update-harga-supplier",  
    name: "Management Pengajuan Barang",
    component: pengajuan_barang_upadte_harga_supplier,
    meta: {
      title: "Update Harga & Supplier"
    }
  },

  {
    path: "/pembayaran-barang/manager-keuangan",
    name: "Management Pembayaran Barang",
    component: approval_pembayaran_barang_manager_keuangan,
    meta: {
      title: "Approval Pembayaran Barang"
    }
  },

  {
    path: "/pembayaran-barang/general-manager",
    name: "Management Pembayaran Barang",
    component: approval_pembayaran_barang_general_manager,
    meta: {
      title: "Approval Pembayaran Barang"
    }
  },

  {
    path: "/pembayaran-barang/print-kasir",
    name: "Management Pembayaran Barang",
    component: approval_pembayaran_barang_print_kasir,
    meta: {
      title: "Print Pembayaran Barang"
    }
  },

  {
    path: "/pembayaran-barang/kasir",
    name: "Management Pembayaran Barang",
    component: pembayaran_barang_kasir,
    meta: {
      title: "Pembayaran Barang"
    }
  },

  {
    path: "/pembayaran-barang/akunting",
    name: "Management Pembayaran Barang",
    component: pembayaran_barang_akunting,
    meta: {
      title: "Pembukuan Barang"
    }
  },

  {
    path: "/delivery/bpb",
    name: "Management Delivery",
    component: delivery_bpb,
    meta: {
      title: "Bukti Pengiriman Barang"
    }
  },

  {
    path: "/delivery/bpb/detail/:id",
    name: "Management Delivery",
    component: delivery_bpb_detail,
    meta: {
      title: "Detail Bukti Pengiriman Barang"
    }
  },

  {
    path: "/delivery/bpb/add",
    name: "Management Delivery",
    component: delivery_bpb_add,
    meta: {
      title: "Tambah Bukti Pengiriman Barang"
    }
  },

  {
    path: "/delivery/bpb/edit/:id",
    name: "Management Delivery",
    component: delivery_bpb_edit,
    meta: {
      title: "Ubah Bukti Pengiriman Barang"
    }
  },

  {
    path: "/delivery/surat-jalan",
    name: "Management Delivery",
    component: delivery_surat_jalan,
    meta: {
      title: "Surat Jalan"
    }
  },

  {
    path: "/delivery/surat-jalan/detail/:id",
    name: "Management Delivery",
    component: delivery_surat_jalan_detail,
    meta: {
      title: "Detail Surat Jalan"
    }
  },

  {
    path: "/delivery/surat-jalan/add",
    name: "Management Delivery",
    component: delivery_surat_jalan_add,
    meta: {
      title: "Tambah Surat Jalan"
    }
  },

  {
    path: "/delivery/surat-jalan/edit/:id",
    name: "Management Delivery",
    component: delivery_surat_jalan_edit,
    meta: {
      title: "Ubah Surat Jalan"
    }
  },

  {
    path: "/delivery/proses-muat",
    name: "Management Delivery",
    component: delivery_proses_muat,
    meta: {
      title: "Proses Muat"
    }
  },

  {
    path: "/delivery/proses-muat/detail/:id",
    name: "Management Delivery",
    component: delivery_proses_muat_detail,
    meta: {
      title: "Detail Proses Muat"
    }
  },

  {
    path: "/vehicle/data",
    name: "Management Vehicle",
    component: vehicle,
    meta: {
      title: "Vehicle"
    }
  },

  {
    path: "/vehicle/data/detail/:id",
    name: "Management Vehicle",
    component: vehicle_detail,
    meta: {
      title: "Detail Vehicle"
    }
  },

  {
    path: "/vehicle/data/add",
    name: "Management Vehicle",
    component: vehicle_add,
    meta: {
      title: "Tambah Vehicle"
    }
  },

  {
    path: "/vehicle/data/edit/:id",
    name: "Management Vehicle",
    component: vehicle_edit,
    meta: {
      title: "Ubah Vehicle"
    }
  },

  // {
  //   path: "/warehouse/order",
  //   name: "Management Warehouse",
  //   component: warehouse_order,
  //   meta: {
  //     title: "Order"
  //   }
  // },

  // {
  //   path: "/warehouse/order/detail/:id",
  //   name: "Management Warehouse",
  //   component: warehouse_order_detail,
  //   meta: {
  //     title: "Detail Order"
  //   }
  // },

  // {
  //   path: "/vehicle/data",
  //   name: "Management Vehicle",
  //   component: vehicle,
  //   meta: {
  //     title: "Vehicle"
  //   }
  // },

  // {
  //   path: "/vehicle/data/detail/:id",
  //   name: "Management Vehicle",
  //   component: vehicle_detail,
  //   meta: {
  //     title: "Detail Vehicle"
  //   }
  // },

  {
    path: "/konfirmasi-pengirirman",
    name: "Management Pengiriman",
    component: warehouse_order,
    meta: {
      title: "Komfirmasi Pengiriman"
    }
  },

  {
    path: "/konfirmasi-pengirirman/detail/:id",
    name: "Management Pengiriman",
    component: warehouse_order_detail,
    meta: {
      title: "Detail Komfirmasi Pengiriman"
    }
  },

  {
    path: "/kasir/supplier",
    name: "Management Kasir",
    component: kasir_supplier,
    meta: {
      title: "Kasir Invoice"
    }
  },

  {
    path: "/kasir/supplier/detail/:id",
    name: "Management Kasir",
    component: kasir_supplier_detail,
    meta: {
      title: "Detail Kasir Invoice"
    }
  },

  {
    path: "/kasir/customer",
    name: "Management Kasir",
    component: kasir_customer,
    meta: {
      title: "Kasir Customer"
    }
  },

  {
    path: "/kasir/customer/detail/:id",
    name: "Management Kasir",
    component: kasir_customer_detail,
    meta: {
      title: "Detail Kasir Customer"
    }
  },

  {
    path: "/kasir/pengajuan-barang",
    name: "Management Kasir",
    component: kasir_pengajuan,
    meta: {
      title: "Pengajuan Barang"
    }
  },

  {
    path: "/kasir/pengajuan-barang/detail/:id",
    name: "Management Kasir",
    component: kasir_pengajuan_detail,
    meta: {
      title: "Detail Pengajuan Barang"
    }
  },

  {
    path: "/promo/data",
    name: "Management Promo",
    component: promo,
    meta: {
      title: "Promo"
    }
  },

  {
    path: "/promo/detail/:id",
    name: "Management Promo",
    component: promo_detail,
    meta: {
      title: "Detail Promo"
    }
  },

  {
    path: "/promo/add",
    name: "Management Promo",
    component: promo_add,
    meta: {
      title: "Tambah Promo"
    }
  },

  {
    path: "/promo/edit/:id",
    name: "Management Promo",
    component: promo_edit,
    meta: {
      title: "Ubah Promo"
    }
  },

  {
    path: "/retur",
    name: "Management Retur",
    component: return_data,
    meta: {
      title: "Retur"
    }
  },

  {
    path: "/retur/detail/:id",
    name: "Management Retur",
    component: return_detail,
    meta: {
      title: "Detail Retur"
    }
  },

  {
    path: "/customer/proses",
    name: "Management Customer",
    component: customer_proses,
    meta: {
      title: "Customer Proses"
    }
  },

  {
    path: "/customer/acc",
    name: "Management Customer",
    component: customer_acc,
    meta: {
      title: "Customer Diterima"
    }
  },

  {
    path: "/customer/reject",
    name: "Management Customer",
    component: customer_reject,
    meta: {
      title: "Histori Customer Rejected"
    }
  },
  {
    path: "/finance/pengajuan",
    name: "Management Kasir",
    component: finance_pengajuan,
    meta: {
      title: "Pengajuan Akunting"
    }
  },
  
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})